import { ComponentSettings } from "../settings/settings";

const settings = {
  permission: {},
  field: {},
  text: {},
  list: {},
  url: {},
  additionalInfo: {},
};

export const example: ComponentSettings<typeof settings> = settings;
